import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "relative grid grid-cols-0 md:grid-cols-12 text-center" }
const _hoisted_2 = { class: "col-span-12 col-start-2 md:col-span-10 md:col-start-2" }
const _hoisted_3 = { class: "mt-12" }
const _hoisted_4 = { class: "-mt-6" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "inline-flex items-center justify-center p-4 bg-brand-button rounded-full" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "inline-flex items-center justify-center p-3 bg-brand-primary rounded-md shadow-lg" }
const _hoisted_9 = ["innerHTML"]

import { RenderFunction } from 'vue';
import {
  PhoneIcon,
  MailIcon,
  HomeIcon
} from '@heroicons/vue/outline';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import { Brand } from '../../services/integration/enums';

type Feature = {
  name: string,
  icon: string|RenderFunction,
  description: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HelpOptions',
  props: {
    features: {}
  },
  setup(__props: any) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const props = __props;

props.features.forEach(feature => {
  if (feature.icon === 'MailIcon') {
    feature.icon = MailIcon;
  } else if (feature.icon === 'PhoneIcon') {
    feature.icon = PhoneIcon;
  } else if (feature.icon === 'HomeIcon') {
    feature.icon = HomeIcon;
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", {
        class: _normalizeClass([_unref(brandService).getName() === _unref(Brand).HIS ? 'font-gotham-bold text-gray-700': 'text-gray-500', "max-w-prose mx-auto text-xl"])
      }, " Confused? We're here for you - choose any help option below ", 2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass([_unref(brandService).getName() === _unref(Brand).HIS ? 'sm:grid-cols-1 lg:grid-cols-2 max-w-2xl mx-auto' : 'sm:grid-cols-2 lg:grid-cols-3', "grid grid-cols-1 gap-8 auto-cols-min items-center justify-center"])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (feature) => {
            return (_openBlock(), _createElementBlock("div", {
              key: feature.name,
              class: "pt-6"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass([_unref(brandService).getName() === _unref(Brand).HIS ? 'bg-white border border-gray-700 border-solid font-sans' : 'bg-gray-50', "flow-root rounded-lg px-8 pb-8 h-full"])
              }, [
                _createElementVNode("div", _hoisted_4, [
                  (_unref(brandService).getName() === _unref(Brand).HIS)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("span", _hoisted_6, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(feature.icon), {
                            class: "h-12 w-12 text-brand-primary",
                            "aria-hidden": "true"
                          }))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("span", _hoisted_8, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(feature.icon), {
                            class: "h-6 w-6 text-brand-button-text",
                            "aria-hidden": "true"
                          }))
                        ])
                      ])),
                  _createElementVNode("h3", {
                    class: _normalizeClass([_unref(brandService).getName() === _unref(Brand).HIS ? 'font-black text-xl' : 'font-medium text-lg', "mt-8 text-gray-900 tracking-tight"])
                  }, _toDisplayString(feature.name), 3),
                  _createElementVNode("div", {
                    class: _normalizeClass([_unref(brandService).getName() === _unref(Brand).HIS ? 'text-xs text-gray-800' : 'xl:text-base text-xs text-gray-500', "mt-5"]),
                    innerHTML: feature.description
                  }, null, 10, _hoisted_9)
                ])
              ], 2)
            ]))
          }), 128))
        ], 2)
      ])
    ])
  ]))
}
}

})